const { formatPhoneNumber } = require("../../../Common/utils/universalFuntions");

const buildSignatureBlocksForAgents = ({ signers, type, rootDocData, contractData, requiredOpenFor, signDetails, brokerFields = {} }) => {
  if (!Array.isArray(signers)) {
    console.log("Unable to build signature block for", signers);
    return "";
  }

  let html = "";
  signers.forEach((element) => {
    const personId = element.personId || element._id;
    const personKey = rootDocData.personKey;
    const uuidKey = element.key || element.personId;
    const isActiveSigner = rootDocData?.openFor === requiredOpenFor && !rootDocData?.checkForDisable?.disabled && ((personId === rootDocData?.builtForId && personKey === rootDocData?.key) || requiredOpenFor === "TITLE_COMPANY") && rootDocData?.signable;
    const signerStatus = isActiveSigner ? "active-signer clickable" : "inactive-signer";
    const signerId = `${requiredOpenFor}_${personId || requiredOpenFor}_key_${uuidKey}`;
    const signatureDateId = `${requiredOpenFor}_${personId || element._id || requiredOpenFor}_key_${uuidKey}`;
    const editIconDataAttr = type === "CO_BUYER_BROKER" ? "data-co-buyer-broker-edit-icon" : type === "CO_SELLER_BROKER" ? "data-co-seller-broker-edit-icon" : "";
    const deleteIconDataAttr = type === "CO_BUYER_BROKER" ? "data-co-buyer-broker-delete-icon" : type === "CO_SELLER_BROKER" ? "data-co-seller-broker-delete-icon" : "";
    const validPersonId = personId?.length === 24 ? personId : null;
    const phoneId = rootDocData.openFor === "BUYER_AGENT" ? `BuyerBrokerPhoneNo_${validPersonId || uuidKey}` : `SellerAgentPhoneNo_${validPersonId || uuidKey}`;
    const emailId = rootDocData.openFor === "BUYER_AGENT" ? `BuyerBrokerEmail_${validPersonId || uuidKey}` : `SellerBrokerEmail_${validPersonId || uuidKey}`;
    html += `
      <div class="signature-block">
        <table class="mt">
          <thead></thead>
          <tbody>
            ${
              rootDocData?.contractType === "ABAD"
                ? `<tr>
                ${brokerFields.firmName ? `<td><div class="mb mt">${brokerFields.firmLabel?.trim()} <span class="ua">${element.firmName || ""}</span></div></td>` : ""}
              </tr>`
                : ""
            }
            <tr>
              <td style="width: 80%;" class="border-bottom-input" id="${signerId}">
                <div class="signature-block ${signerStatus}" data-signerId="${personId}" data-signerKey="${uuidKey}"></div>
              </td>
              <td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureDate="${signatureDateId}"></td>
              ${brokerFields?.time ? `<td style="width: 10%; vertical-align: bottom;" class="border-bottom-input ua tb" data-signatureTime="${signatureDateId}"></td>` : ''}
            </tr>
            <tr>
             <td>
              <div style="display: flex; align-items: flex-start; gap: 0.3rem; flex-wrap: wrap;">
             ${brokerFields.signatureLabel ? brokerFields.signatureLabel.trim() : "Broker's Name:"} <span class="ua" data-signerFullName="${signerId}">${element.fullName || ""}</span>
                <i class="bi bi-pencil-square no-print clickable" data-block-is-for="${type}"  ${editIconDataAttr}  data-signer-personId="${personId}" data-signer-uuid-key="${uuidKey}" data-edit-modal-title="${brokerFields.editModalTitle || ""}" data-labelType="${brokerFields.labelType || ""}"  style="color: blue"></i>
             ${
               signers.length > 1 || rootDocData.contractType === "DC_ADBA"
                 ? `
               <i class="bi bi-trash3 no-print clickable" data-block-is-for="${type}" ${deleteIconDataAttr} data-signer-personId="${personId}" data-signer-uuid-key="${uuidKey}"  data-labelType="${brokerFields.labelType || ""}" style="color: #178DFA"></i>`
                 : ""
             }
                 </div>
              </td>
              <td>Date</td>
              ${brokerFields?.time ? `<td>Time</td>` : ''}
            </tr>
            ${
              rootDocData?.contractType !== "ABAD"
                ? `<table class="tableWidth" style="border: 0;">
                ${brokerFields.firmName ? `<tr><td>${brokerFields?.firmLabel || "Brokerage Firm’s Name:"} <span class="ua">${element.firmName || ""}</span>${brokerFields?.team && element?.team ? ` Team: <span class="ua">${element.team || ""}</span>` : ''}</td></tr>` : ""}
                ${brokerFields.firmLicense ? `<tr><td>${brokerFields?.firmLicenseLabel || "Brokerage Firm’s License #:"} <span class="ua">${element.firmLicense || ""}</span></td></tr>` : ""}
                ${brokerFields.license ? `<tr><td>${brokerFields?.licenseLabel || "Broker's License #:"} <span class="ua">${element.license || ""}</span></td></tr>` : ""}
                ${brokerFields.address ? `<tr><td style="width: 30%;">${brokerFields?.addressLabel || "Address:"} <span class="ua">${element.address || ""}</span></td></tr>` : ""}
                ${brokerFields.phoneNumber ? `<tr id="${phoneId}"><td>${brokerFields?.phoneNumberLabel || "Phone No.:"} <span class="ua">${formatPhoneNumber(element.phoneNumber)}</span></td></tr>` : ""}
                ${brokerFields.faxNumber ? `<tr><td>${brokerFields?.faxNumberLabel || "Fax No.:"} <span class="ua">${formatPhoneNumber(element.faxNumber)}</span></td></tr>` : ""}
                ${brokerFields.email ? `<tr id="${emailId}"><td>${brokerFields?.emailLabel || "Email Address:"} <span class="ua">${element.email || ""}</span></td></tr>` : ""}
              </table>`
                : ""
            }
          </tbody>
        </table>
      </div>`;
  });

  return html;
};

export default buildSignatureBlocksForAgents;
